import { isDefined, isNotDefined } from '@sgme/fp';
import type { ValueFormatterFunc } from 'ag-grid-community';
import { formatDate } from 'date-fns';
import type { FormatDateOptions, IntlShape } from 'react-intl';

import type { ISODate, ISODateTime } from '@/types/date.ts';

export const basicTimeFormat = (value: ISODateTime): string => {
  if (isNotDefined(value) || value === 'null') {
    return '';
  }
  try {
    return formatDate(value, 'HH:mm:ss');
  } catch (e) {
    console.error('Error formatting date', e);
  }
  return '';
};

const dateFormattingOptions: FormatDateOptions = { dateStyle: 'medium' } as const;

export const dateFormatterBuilder: <T>(intl: IntlShape) => ValueFormatterFunc<T, ISODate> =
  ({ formatDate }) =>
  ({ value }) =>
    isDefined(value) &&
    // preventive, analogous abberation found in prod
    value !== 'null'
      ? formatDate(value, dateFormattingOptions)
      : '';

export const datetimeFormatterBuilder: <T>(intl: IntlShape) => ValueFormatterFunc<T, ISODateTime> =
  ({ formatDate }) =>
  ({ value }) =>
    isDefined(value) &&
    // preventive, analogous abberation found in prod
    value !== 'null'
      ? formatDate(value, { dateStyle: 'medium', timeStyle: 'short' })
      : '';
